import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Search, Loader2 } from "lucide-react";

export default function TaricTool() {
  const [q, setQ] = useState("");
  const [submitted, setSubmitted] = useState("");

  const { data, isFetching } = useQuery({
    queryKey: ["taric", submitted],
    queryFn: async () => (await api.get(`/taric/search`, { params: { q: submitted, limit: 15 } })).data,
    enabled: submitted !== "" || submitted === "",
  });

  return (
    <div className="animate-fade-in">
      <header className="h-14 border-b border-zinc-800 flex items-center px-6">
        <h1 className="font-heading text-lg font-semibold tracking-tight">TARIC Lookup</h1>
        <span className="ml-3 text-xs font-mono text-zinc-500">local sample TARIC · FTS5</span>
      </header>
      <div className="p-6">
        <form onSubmit={(e) => { e.preventDefault(); setSubmitted(q); }} className="flex gap-2 mb-4 max-w-xl">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
            <input data-testid="taric-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search goods description or HS code…"
              className="w-full bg-zinc-900 border border-zinc-800 rounded-sm pl-9 pr-3 py-2 text-sm font-mono focus:border-blue-500 outline-none" />
          </div>
          <button data-testid="taric-search-btn" className="bg-blue-600 hover:bg-blue-500 text-white text-sm px-4 py-2 rounded-sm">Search</button>
        </form>

        <div className="border border-zinc-800 rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-zinc-950 text-[10px] uppercase tracking-wider text-zinc-500">
                <th className="text-left font-medium py-2 px-3">HS Code</th>
                <th className="text-left font-medium py-2 px-3">Description</th>
                <th className="text-left font-medium py-2 px-3">MFN</th>
                <th className="text-left font-medium py-2 px-3">Anti-dumping</th>
                <th className="text-left font-medium py-2 px-3">Preferential</th>
              </tr>
            </thead>
            <tbody>
              {isFetching && <tr><td colSpan={5} className="py-8 text-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin inline" /></td></tr>}
              {(data?.results || []).map((r) => (
                <tr key={r.hs_code} data-testid={`taric-row-${r.hs_code}`} className="border-t border-zinc-800/60 hover:bg-zinc-900 transition-colors duration-150">
                  <td className="py-2 px-3 font-mono text-blue-400">{r.hs_code}</td>
                  <td className="py-2 px-3 text-zinc-300">{r.description}</td>
                  <td className="py-2 px-3 font-mono text-zinc-200">{r.mfn_duty}%</td>
                  <td className="py-2 px-3 text-xs text-amber-400">{r.anti_dumping || "—"}</td>
                  <td className="py-2 px-3 text-xs text-emerald-400">{r.preferential || "—"}</td>
                </tr>
              ))}
              {!isFetching && (data?.results || []).length === 0 && <tr><td colSpan={5} className="py-8 text-center text-zinc-500 text-sm">No matches.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
